import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';
import type { IObjectType } from '../../../stores/model/metamodel/object_type';

/**
 * Check if an object has at least 1 attribute.
 */
class ObjectAttributeCheck extends Check<IObjectType> {
  static description = 'Check object attributes';

  check(): Report {
    this.report = new Report();

    if(this.element.attributes.length > 0) {
      this.report.addMessage(MessageType.INFORMATION, 'Object has at least 1 attribute.', this, this.element);
    } else {
      this.report.addMessage(MessageType.WARNING, 'Object doesn\'t have attributes.', this, this.element);
    }

    return this.report;
  }

}

export default ObjectAttributeCheck;
